<h1 mat-dialog-title class="no-margin">
  Importazione Sedi
  <mat-icon class="close-icon" (click)="onClose()">close</mat-icon>
</h1>

<div style="font-size: 18px; padding : 25px;" class="warn">
  <p>
    Se si procede con l'importazione delle Sedi verranno aggiunte tutte le sedi non presenti nella base dati e aggiornati i dati di quelle gia presenti.
  </p>
  <div style="text-align: center">
    <strong style="text-align: center;">Si è sicuri di voler procedere?</strong>
  </div>
</div>

<div mat-dialog-actions class="actions">
  <button mat-fab extended class="searchbox-buttons ripristina-button" (click)="onClose()">
    <mat-icon>close</mat-icon>Chiudi
  </button>
  <button mat-fab extended class="searchbox-buttons save-button" (click)="procedi()">
    <mat-icon>check</mat-icon>Procedi
  </button>
</div>
